import { isPrimitive } from "is-what"
import { domtify } from "@/core.js"

domtify.isPrimitive = isPrimitive
